import Table from 'components/commons/table'
import { TABLE_PRODUCT_TYPE } from 'configs/product/configTableProductType'
import { ACTION_TYPE } from 'constants/constant'
import { Button } from 'avo-ui'
import { FormProductType } from 'components/product/product-type/FormProductType'
import icTrash from 'assets/images/ic-trash.svg'
import ModalDelete from 'components/commons/modal-delete'
import icAddSquare from 'assets/images/ic-add-square.svg'

export const ProductType = ({
    dataList,
    query,
    onChangeQuery,
    onActionRow,
    selectedIds,
    onSelectItemHandler,
    modal,
    setShowModal,
    onDelete,
    productTypeDetail,
    optionsProduct,
    onSearchProduct,
    onHideForm,
    onChangeForm,
    errorForm,
    onSubmit,
    isLoading,
    isLoadingDetail,
    isDeleting,
    isCreating,
    isUpdating,
    isResetSelectedItem,
}) => {
    return (
        <div className={'flex flex-col px-9 py-4'}>
            <div className={'flex justify-between'}>
                <Button
                    type={'outline'}
                    title={'Delete'}
                    icon={icTrash}
                    disabled={!selectedIds?.length}
                    onClick={() => onActionRow({ actionType: ACTION_TYPE.DELETE })}
                />
                <Button
                    type={'outline'}
                    icon={icAddSquare}
                    title={'Create Product Type'}
                    onClick={() => onActionRow({ actionType: ACTION_TYPE.CREATE })}
                />
            </div>
            <Table
                className={'my-3'}
                name={TABLE_PRODUCT_TYPE.name}
                columns={TABLE_PRODUCT_TYPE.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onSelectItem={(val) => onSelectItemHandler(val)}
                onClickItem={onActionRow}
                onChangePage={(val) => onChangeQuery({ page: val })}
                loading={isLoading}
                isResetSelectedItem={isResetSelectedItem}
            />
            {modal?.delete && (
                <ModalDelete
                    show={modal?.delete}
                    onHide={() => setShowModal({ delete: false })}
                    description={'Are You Sure to Delete Product Type'}
                    totalData={selectedIds?.length}
                    isLoading={isDeleting}
                    onDelete={onDelete}
                />
            )}
            {modal?.form && (
                <FormProductType
                    show={modal?.form}
                    onHideForm={onHideForm}
                    dataProductType={productTypeDetail}
                    isLoading={isCreating || isUpdating}
                    isLoadingDetail={isLoadingDetail}
                    optionsProduct={optionsProduct}
                    onSearchProduct={onSearchProduct}
                    onChangeForm={onChangeForm}
                    errorForm={errorForm}
                    onSubmit={onSubmit}
                />
            )}
        </div>
    )
}
